<template>
  <div class="right-container">
    <div class="about" :style="eventInfo.eventTitle.length > 100 ? 'width: 50%' : 'width: 45%'">
      <div class="event-info">
        <div class="event-title" :style="eventInfo.eventTitle.length > 30 && 'font-size: 7px'">
          {{ eventInfo.eventTitle }}
        </div>
        <div class="event-date" :style="eventInfo.eventTitle.length > 30 && 'font-size: 6px'">
          {{ eventInfo.eventDate }}
        </div>
        <div class="event-address" :style="eventInfo.eventTitle.length > 30 && 'font-size: 5px'">
          {{ eventInfo.eventAddress }}
        </div>
        <div class="ticket-type" v-if="hidePrice">{{ ticketName }}</div>
      </div>
      <div class="logo">
        <img
          v-if="!printDesign"
          class="logo-img"
          src="../../../public/assets/logo_coreevent.svg"
          alt="Coreevent-logo"
        />
      </div>
    </div>
    <div
      class="codes"
      :style="hidePrice && 'flex-direction: row-reverse !important; padding-bottom: 20px'"
    >
      <canvas class="QRcode" ref="qrcode" />
      <canvas v-if="!hidePrice" class="barcode" ref="barcode" />
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'
import JsBarCode from 'jsbarcode'

export default {
  name: 'pdf-ticket-right',
  props: [
    'qrcode',
    'barcode',
    'eventInfo',
    'printDesign',
    'hidePrice',
    'ticketName',
  ],
  methods: {
    async generateBarcode(value) {
      const canvas = this.$refs.barcode
      JsBarCode(canvas, value, {
        format: 'ean13',
        lineColor: '#000',
        height: 60,
        displayValue: true,
      })
    },
    async generateQrCode(value) {
      const canvas = this.$refs.qrcode
      return QRCode.toCanvas(canvas, value, {
        width: 65,
        margin: 0,
      })
    },
  },
  async mounted() {
    this.generateQrCode(this.qrcode)
    !this.hidePrice && this.generateBarcode(this.barcode)
  },
}
</script>

<style scoped>
.right-container {
  background: transparent;
  height: 100%;
  width: calc(210mm * (0.2));
  display: flex;
  flex-direction: column;
  writing-mode: vertical-rl;
  transform: rotate(180deg);
}

.event-title {
  font-family: 'Raleway';
  color: black;
  letter-spacing: -0.03em;
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
}
.event-date {
  font-family: 'Source Sans Pro';
  letter-spacing: -0.03em;
  font-style: normal;
  font-weight: 400;
  font-size: 7px;
}
.event-address {
  font-family: 'Source Sans Pro';
  font-style: normal;
  letter-spacing: -0.03em;
  font-weight: 400;
  font-size: 7px;
}
.event-info {
  max-height: 40mm;
  margin-right: 16px;
  margin-top: 20px;
}
.about {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.logo {
  transform: rotate(180deg);
  height: 19mm;
  width: 10mm;
  margin-bottom: 30px;
  margin-right: 16px;
}
.logo-img {
  height: 100%;
  width: 100%;
}

.codes {
  display: flex;
  flex-direction: row;
  width: 21mm;
}
.QRcode {
  transform: rotate(180deg);
  margin-top: 18px;
  height: 17mm;
  width: 17mm;
}
.barcode {
  transform: rotate(90deg);
  margin-right: 5px;
  margin-top: 73px;
  align-self: center;
  width: 42mm;
  height: 12mm;
}
.ticket-type {
  font-family: 'Raleway';
  color: black;
  letter-spacing: -0.03em;
  font-style: normal;
  font-weight: 600;
  margin-right: 25px;
  font-size: 9px;
}
</style>
